import { useParams } from 'react-router-dom';

import { useGetDoc } from '@/api/queries/useGetDoc';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useGetSubset } from '@/api/queries/useGetSubset';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { LargeDocViewer } from '@/new/components/doc-viewer/large-doc-viewer';
import { useSubsetBreadcrumbs } from '@/new/hooks/use-subset-breadcrumbs';

export function Document() {
  const { matterId, subsetId, docId } = useParams();
  if (!matterId || !subsetId || !docId) return;

  const { data: matter } = useGetMatterV2(matterId);
  const { data: subset } = useGetSubset(matterId, subsetId);
  const { data: doc } = useGetDoc(subsetId, docId);

  const breadcrumbItems = useSubsetBreadcrumbs({
    matterId,
    subsetId,
    matter,
    subset,
    currentPage: { label: 'Documents', path: 'docs' },
  });

  return (
    <div className="flex h-full flex-col">
      <Breadcrumb
        items={[
          ...breadcrumbItems.map((item, index) =>
            index === breadcrumbItems.length - 1 ? { ...item, active: false } : item,
          ),
          {
            href: `/matters/${matterId}/subsets/${subsetId}/docs/${docId}`,
            label: doc?.file.name ?? '',
            active: true,
          },
        ]}
      />

      <div className="flex-1 overflow-hidden px-8 text-sm">
        <LargeDocViewer docId={docId} subsetId={subsetId} />
      </div>
    </div>
  );
}
